export const companiesCompanyIdOauthMcpSettingsPartnerPolicies =
  "/companies/:company_id/oauth_mcp_settings/partner_policies";
